// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface InboxIconSignature {
  Element: SVGSVGElement;
}

export const InboxIcon: TOC<InboxIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.707 8.707L15.293 7.293L13 9.586V1H11V9.586L8.707 7.293L7.293 8.707L12 13.414L16.707 8.707ZM15.586 14L13.586 16H10.414L8.414 14H2V22H22V14H15.586ZM4 16V20H20V16H16.414L14.414 18H9.586L7.586 16H4Z"/>
</svg>
</template>;